import { getJson, putJson } from './client'
import type { OrgAssignment, OrgsView } from '../types/orgs'

// The orgs in the tenant: who is in each, which of them is the caller's, and who is in none. The
// switcher at the top of the sidebar is the only reader. Asking WHICH orgs exist is not itself
// scoped, so the question carries no org of its own.
const orgs = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/orgs`
const userOrg = (spoke: string, userId: string) =>
  `/api/spokes/${encodeURIComponent(spoke)}/scout/users/${encodeURIComponent(userId)}/org`

export const orgsApi = {
  list: (spoke: string) => getJson<OrgsView>(orgs(spoke), { org: undefined }),
  /** Place a person in an org (admins only). For the people minted by name, with no mail domain to read. */
  place: (spoke: string, userId: string, key: string) => putJson<OrgAssignment>(userOrg(spoke, userId), { key }),
}
